import React, { Component } from 'react';
import Task from './Task';
import AddTask from './AddTask';
import './Task.css'

class TodoList extends Component {
    state = {
        tasks: [
            { id: 1, task: 'Buy groceries' },
            { id: 2, task: 'Go for a walk' }
        ]
    };

    renderTasks() {
        return this.state.tasks.map(task => (
            <Task key={task.id} id={task.id} task={task.task} onDeleteTask={this.handleDeleteTask} />
        ));
    }

    handleAddTask = task => {
        const tasks = [...this.state.tasks];
        tasks.push({ id: tasks.length + 1, task });
        this.setState({ tasks });
    };

    handleDeleteTask = id => {
        const tasks = [...this.state.tasks];
        const index = tasks.findIndex(task => task.id === id);
        tasks.splice(index, 1);
        this.setState({ tasks });
    };

    render() {
        return (
            <div className='card p-5  shadow-lg p-3 mb-5 bg-body' >
                <AddTask onAddTask={this.handleAddTask} />
                <ul className='task'>{this.renderTasks()}</ul>
            </div>
        );
    }
}

export default TodoList;